import { useCallback } from 'react';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withSequence,
  withSpring,
  withTiming,
} from 'react-native-reanimated';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Jump-on-touch shared by the glass navbar surfaces. A touch pops the surface
 * up and springs it back to rest on its own, so holding a press never leaves
 * it enlarged.
 */
export const useNavbarPressScale = () => {
  //
  // ─── Shared Values ───────────────────────────────────────────────────

  const pressScaleSV = useSharedValue(1);

  // ─── Handlers ────────────────────────────────────────────────────────

  const handlePressIn = useCallback(() => {
    pressScaleSV.value = withSequence(
      withTiming(PRESS_JUMP_SCALE, PRESS_JUMP_TIMING_CONFIG),
      withSpring(1, PRESS_SETTLE_SPRING_CONFIG),
    );
  }, [pressScaleSV]);

  // ─── Animated Styles ─────────────────────────────────────────────────

  const pressScaleAnimatedStyles = useAnimatedStyle(() => ({
    transform: [{ scale: pressScaleSV.value }],
  }));

  // ─────────────────────────────────────────────────────────────────────

  return { handlePressIn, pressScaleAnimatedStyles };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const PRESS_JUMP_SCALE = 1.03;

const PRESS_JUMP_TIMING_CONFIG = {
  duration: theme.transitions.short,
  easing: Easing.out(Easing.quad),
};
const PRESS_SETTLE_SPRING_CONFIG = { damping: 10, stiffness: 180, mass: 0.8 };
